import type { TripTripTag } from '@bambi/api-client/schemas';

export const convertTripTagsToSelectOptionWithColor = (tags: TripTripTag[]) => {
  return tags.map((tag) => ({
    label: tag.tag_name,
    value: tag.tag,
    color: tag.color_hex,
  }));
};
